<template>
  <div />
</template>

<script>
import { userManager } from "@/utils/identity";

export default {
  async mounted() {
    await userManager.signinSilentCallback();
  }
};
</script>
